import { SET_MONEY_LOAN_INFO } from '../action/simple-action';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_MONEY_LOAN_INFO:
      return { ...state, ...action.value };
    default: return state;
  }
};
